import { Box, FormGroup, Link } from '@mui/material'
import Chip from '@mui/material/Chip'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { Typography, ListItemText } from '@mui/material'
import Button from 'components/Common/Button'
import {
  fetchDeliverymathods,
  fetchExpiration,
  fetchRecipient,
  generatePassword,
  triggerEmail,
  triggerApprovalEmail,
} from 'api/VaultApi'
import { useEffect, useState } from 'react'
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from 'themes/theme'
import { saveAs, encodeBase64 } from '@progress/kendo-file-saver'
import Tooltip from '@mui/material/Tooltip'
import CopyIcon from '@mui/icons-material/ContentCopy'
import DownloadIcon from '@mui/icons-material/Download'
import IconButton from '@mui/material/IconButton'
import { SuccessIcon } from 'assets'
import { validateEmail } from 'utils/helper'
import { useSelector } from 'react-redux'
import routes from 'routes'
import { useNavigate } from 'react-router-dom'

const ShareModal = ({ vaultInfo, onClose, data, docs, datam, callBack, rowData }) => {
  const [deliveryMethods, updateDeliveryMethods] = useState([])
  const [expiration, updateExpiration] = useState([])
  const [showError, setError] = useState(false)
  const [loading, setLoader] = useState(false)
  const [recipient, updaterecipientEmails] = useState([])
  const [securePassword, updatePassword] = useState(false)
  const [formData, updateForm] = useState()
  const [copyText, updateCopyText] = useState('Copy to clipboard')
  const [shared, updateShared] = useState(false)
  const { business_info } = useSelector(state => state.apiResponseReducers.dashboardInfo)
  const isClaimed =
    data.secShareType === 'article'
      ? true
      : business_info.claimed_business_details
      ? business_info.claimed_business_details.isClaimed
      : false
  const navigate = useNavigate()
  const [formErrors, setFormErrors] = useState({
    email: false,
  })
  const selectedDoc = datam ? [datam] : data.selectedId
  const filter = createFilterOptions()
  const handleDownload = () => {
    const dataURI = 'data:text/plain;base64,' + encodeBase64(securePassword.password)
    saveAs(dataURI, 'password.txt')
  }
  const handleInput = e => {
    const { name, value } = e
    updateForm({ ...formData, [name]: value })
  }

  const goToDashboard = () => {
    navigate(routes.home)
  }

  useEffect(() => {
    fetchDeliverymathods(data => updateDeliveryMethods(data))
    fetchExpiration(data => updateExpiration(data))
  }, [])

  const handleSubmit = e => {
    e.preventDefault()
    setLoader(true)
    triggerEmail(
      {
        ...formData,
        ...data,
        beneficiaryOwnerId: data.secShareType === 'article' ? [] : selectedDoc,
        articleId: data.secShareType === 'article' ? selectedDoc : [],
        vaultId: vaultInfo.vault_id,
        passwordGenId: securePassword ? securePassword.passwordGenId : 0,
        password: securePassword ? securePassword.password : '',
      },
      (val, err) => {
        setError(err)
        updateShared(val)
        callBack(true)
        setLoader(false)
      },
    )
  }
  const handleBOSubmit = e => {
    e.preventDefault()
    setLoader(true)
    triggerApprovalEmail(
      {
        ...formData,
        ...data,
        beneficialOwnerId: data.secShareType === 'article' ? [] : selectedDoc,
        articleId: data.secShareType === 'article' ? selectedDoc : [],
        vaultId: vaultInfo.vault_id,
        passwordGenId: securePassword ? securePassword.passwordGenId : 0,
        password: securePassword ? securePassword.password : '',
      },
      (val, err) => {
        setError(err)
        updateShared(val)
        callBack(true)
        setLoader(false)
      },
    )
  }
  const findDay = val => {
    let dayValue
    switch (val) {
      case '24HRS':
        dayValue = '24 Hours'
        break
      case '48HRS':
        dayValue = '48 Hours'
        break
      case '72HRS':
        dayValue = '3 Days'
        break
      case '96HRS':
        dayValue = '4 Days'
        break
      case '120HRS':
        dayValue = '5 Days'
        break
      case '144HRS':
        dayValue = '6 Days'
        break
      case '168HRS':
        dayValue = '7 Days'
        break
      default:
        dayValue = '24 Hours'
    }
    return dayValue
  }

  const trimText = str => {
    if (str.length > 30) {
      return `${str.substring(0, 30)}...`
    } else {
      return str
    }
  }

  return (
    <Box
      component="form"
      className="shareModal"
      onSubmit={data.secShareType === 'article' ? handleSubmit : handleBOSubmit}
    >
      {data.secShareType === 'article'
        ? !shared && (
            <Box fontSize="24px" color="#25245F" fontWeight={600} textAlign="center" marginY="30px">
              Share Documents
            </Box>
          )
        : !shared && (
            <Box fontSize="24px" color="#25245F" fontWeight={600} textAlign="center" marginY="30px">
              Share Beneficial Owners
            </Box>
          )}
      {shared ? (
        <Box
          height="200px"
          marginY="20px"
          display="flex"
          textAlign="center"
          flexDirection="column"
          justifyContent="center"
          gap="30px"
        >
          <Box>
            {/* <img src={iconSuccess} alt="success" height={50} width={50} /> */}
            <SuccessIcon />
          </Box>
          {data.secShareType === 'article' ? (
            <Box
              fontSize="14px"
              marginX="10px"
              color="#66668F"
              display="flex"
              textAlign="center"
              justifyContent="center"
            >
              Attached documents shared successfully.
            </Box>
          ) : (
            <Box
              fontSize="14px"
              marginX="10px"
              color="#66668F"
              display="flex"
              textAlign="center"
              justifyContent="center"
            >
              A request has been sent to the beneficial owner(s) for <br />
              permission to share their information. You will be notified <br />
              via email once this is done.
            </Box>
          )}
        </Box>
      ) : (
        <Grid container spacing={2}>
          {isClaimed ? (
            <>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  size="small"
                  ListboxProps={{
                    sx: {
                      padding: '8px',
                      boxshadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
                      borderRadius: '5px',
                    },
                  }}
                  // fullWidth
                  noOptionsText={
                    <Typography variant="h6" style={{ fontFamily: 'poppins', fontWeight: 'bold', fontSize: '13px' }}>
                      No options
                    </Typography>
                  }
                  onChange={(event, newValue) => {
                    if (newValue) {
                      updateForm({
                        ...formData,
                        recipient: newValue ? newValue.name.replace('Add ', '') : newValue.name,
                        recipientEmail: newValue.email,
                        recipientId:
                          newValue.recipientId && formData && formData.recipientEmail ? newValue.recipientId : 0,
                      })
                    } else {
                      updateForm({
                        ...formData,
                        recipient: '',
                        recipientEmail: [],
                        recipientId: 0,
                      })
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params)
                    const { inputValue } = params
                    // Suggest the creation of a new value
                    const isExisting = options.some(option => inputValue === option)
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({ name: `Add ${inputValue}`, email: [] })
                    }
                    return filtered
                  }}
                  onInputChange={e =>
                    e && fetchRecipient({ ...vaultInfo, name: e.target.value }, data => updaterecipientEmails(data))
                  }
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  options={recipient}
                  getOptionLabel={option => {
                    if (typeof option.name === 'string') {
                      return option.name.replace('Add ', '')
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue.replace('Add ', '')
                    }
                    // Regular option
                    return option.replace('Add ', '')
                  }}
                  renderOption={(props, option) => {
                    return (
                      <>
                        <ListItemText key={option.name} {...props} sx={{ borderRadius: '5px' }}>
                          <Typography sx={{ fontSize: '14px', color: '#66668f' }}>{option.name}</Typography>
                        </ListItemText>
                      </>
                    )
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Recipient Name"
                      required
                      // sx={{
                      //   width: '275px',
                      // }}
                      // error
                      // helperText='This field required'
                      bgwhite
                      InputLabelProps={{ shrink: false }}
                    />
                  )}
                  componentsProps={{
                    popper: {
                      className: `CustomAutoComplete`,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  multiple
                  autoSelect
                  options={formData && formData.recipientEmail ? formData.recipientEmail : []}
                  onChange={(event, newValue) => {
                    if (validateEmail(newValue[newValue.length - 1]) || !newValue.length) {
                      setFormErrors({ ...formErrors, email: false })
                      handleInput({ name: 'recipientEmail', value: newValue })
                    } else {
                      setFormErrors({ ...formErrors, email: 'Please enter valid email address.' })
                    }
                  }}
                  value={formData && formData.recipientEmail ? formData.recipientEmail : []}
                  freeSolo
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={<Typography sx={{ fontSize: '14px' }}>{option}</Typography>}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      // sx={{
                      //   width: '275px',
                      // }}
                      label={'Email'}
                      bgwhite
                      error={formErrors.email}
                      helperText={formErrors.email ? formErrors.email : ''}
                      InputLabelProps={{ shrink: false }}
                      size="small"
                      required={formData && formData.recipientEmail ? !formData.recipientEmail.length : true}
                    />
                  )}
                  componentsProps={{
                    popper: {
                      className: 'CustomAutoComplete',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Autocomplete
                  disablePortal
                  ListboxProps={{
                    sx: {
                      padding: '8px',
                      //   marginTop: '10px',
                      boxshadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
                      borderRadius: '5px',
                    },
                  }}
                  componentsProps={{
                    popper: {
                      className: 'CustomAutoComplete',
                    },
                  }}
                  options={deliveryMethods}
                  getOptionLabel={option => {
                    return option.description
                  }}
                  onChange={(event, newValue) => {
                    newValue && updateForm({ ...formData, deliveryMethod: newValue.code })
                    if (newValue && newValue.code === 'EPWDZIP') {
                      generatePassword(vaultInfo, data => {
                        updatePassword(data)
                        updateForm({
                          ...formData,
                          password: data.password,
                          passwordGenId: data.passwordGenId,
                          deliveryMethod: newValue.code,
                          expiryInterval: '24HRS',
                          message: '',
                        })
                      })
                    } else {
                      updateForm({
                        ...formData,
                        password: 'EOTSURI',
                        passwordGenId: 0,
                        deliveryMethod: 'EOTSURI',
                        message: '',
                      })
                      updatePassword(false)
                    }
                  }}
                  renderOption={(props, option) => {
                    return (
                      <>
                        <ListItemText
                          key={option.code}
                          {...props}
                          sx={{ borderRadius: '5px', border: 'none !important' }}
                        >
                          <Typography sx={{ fontSize: '14px', color: '#66668f' }}>{option.description}</Typography>
                        </ListItemText>
                      </>
                    )
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      // sx={{
                      //   width: '275px',
                      // }}
                      bgwhite
                      InputLabelProps={{ shrink: false }}
                      size="small"
                      label="Delivery Method"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                {!securePassword && (
                  <Autocomplete
                    componentsProps={{
                      popper: {
                        className: 'CustomAutoComplete',
                      },
                    }}
                    ListboxProps={{
                      sx: {
                        padding: '8px',
                        //   marginTop: '10px',
                        boxshadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
                        borderRadius: '5px',
                      },
                    }}
                    options={expiration}
                    onChange={(event, newValue) => {
                      newValue && handleInput({ name: 'expiryInterval', value: newValue.code })
                    }}
                    getOptionLabel={option => {
                      return findDay(option.code)
                    }}
                    renderOption={(props, option) => {
                      return (
                        <>
                          <ListItemText
                            key={option.code}
                            {...props}
                            sx={{ borderRadius: '5px', border: 'none !important' }}
                          >
                            <Typography sx={{ fontSize: '14px', color: '#66668f' }}>{findDay(option.code)}</Typography>
                          </ListItemText>
                        </>
                      )
                    }}
                    renderInput={params => {
                      return (
                        <TextField
                          {...params}
                          // sx={{
                          //   width: '275px',
                          // }}
                          bgwhite
                          required
                          InputLabelProps={{ shrink: false }}
                          size="small"
                          label="Expiration"
                          value={params.inputProps.value.description}
                        />
                      )
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{
                    '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0A78CD !important',
                    },
                  }}
                  InputLabelProps={{ shrink: false }}
                  bgwhite
                  fullWidth
                  size="small"
                  onChange={e => handleInput({ name: 'subject', value: e.target.value })}
                  label="Email Subject"
                  variant="outlined"
                />
              </Grid>
              {securePassword && (
                <Grid item xs={12}>
                  <Box marginLeft="2px">
                    <Box color="#25245F" fontSize="14px" fontWeight={500}>
                      System Generated Password
                    </Box>
                    <Box display="flex" alignItems="center" gap="30px" color="#25245F">
                      <Box paddingY="10px" fontWeight={600}>
                        {securePassword.password}
                      </Box>
                      <Box display="flex" gap="5px">
                        <Tooltip title={<Typography variant="body2">{copyText}</Typography>}>
                          <IconButton
                            type="button"
                            onClick={() => {
                              updateCopyText('Copied to Clipboard')
                              navigator.clipboard.writeText(securePassword.password)
                            }}
                          >
                            <CopyIcon sx={{ fontSize: '18px' }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={<Typography variant="body2">Download</Typography>}>
                          <IconButton type="button" onClick={handleDownload}>
                            <DownloadIcon sx={{ fontSize: '18px' }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>
                    <Box color="#25245F">
                      Please save, write down or download the text file containing your system generated password.{' '}
                      <br />
                      You will be responsible for sharing it with recipient of this email.
                    </Box>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  InputLabelProps={{ shrink: false }}
                  sx={{
                    '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0A78CD !important',
                    },
                  }}
                  bgwhite
                  fullWidth
                  size="small"
                  multiline
                  onChange={e => handleInput({ name: 'message', value: e.target.value })}
                  rows={4}
                  label="Message"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <Box fontWeight={600} fontSize="14px">
                    {data.secShareType === 'article' ? (
                      <Typography variant="body2M" color="#25245F">
                        Attached Items
                      </Typography>
                    ) : (
                      <Typography variant="body2M" color="#25245F">
                        Beneficial Owners to be shared
                      </Typography>
                    )}
                  </Box>
                  <ul style={{ listStyleType: 'disc', color: '#66668F' }}>
                    {docs.map(val => {
                      return (
                        <li
                          className={
                            selectedDoc.includes(
                              data.secShareType === 'article' ? val.t_vault_article_id : val.t_beneficial_owner_id,
                            ) ? (
                              <li></li>
                            ) : (
                              'd-none'
                            )
                          }
                        >
                          {data.secShareType === 'article' ? (
                            <span title={val.article_name}>{trimText(val.article_name)}</span>
                          ) : (
                            <span title={val.business_name ? val.business_name : `${val.first_name} ${val.last_name}`}>
                              {trimText(val.business_name ? val.business_name : `${val.first_name} ${val.last_name}`)}
                            </span>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                </FormGroup>
              </Grid>
            </>
          ) : (
            <Box
              marginY="30px"
              display="flex"
              textAlign="center"
              flexDirection="column"
              justifyContent="center"
              gap="20px"
            >
              <Box fontSize="14px" lineHeight={2} padding={2}>
                We are unable to share the requested form until you have “claimed” your business. Please visit the
                <Link
                  onClick={goToDashboard}
                  target="_blank"
                  underline="hover"
                  sx={{
                    marginLeft: '4px',
                  }}
                >
                  <Typography
                    component="span"
                    variant="button3"
                    color="secondary"
                    sx={{ cursor: 'pointer', fontSize: '14px' }}
                  >
                    Home
                  </Typography>
                </Link>
                &nbsp;page to claim your business.
              </Box>
            </Box>
          )}
        </Grid>
      )}
      {showError && (
        <Box
          color="#D14343"
          paddingY="13px"
          paddingX="20px"
          sx={{ background: '#FDF6F6', border: '1px solid #D14343', width: '100%' }}
          borderRadius="8px"
          width="300px"
          textAlign="center"
        >
          Something went wrong. Please try after some time.
        </Box>
      )}
      <Box display="flex" justifyContent="center" marginY="15px" gap="15px">
        <Button
          sx={{ width: '220px', marginBottom: '15px' }}
          onClick={() => onClose()}
          type={shared ? PRIMARY_BUTTON : SECONDARY_BUTTON}
        >
          {shared ? 'Close' : 'Cancel'}
        </Button>
        {!shared && isClaimed && (
          <Button sx={{ width: '220px' }} submit loading={loading} type={PRIMARY_BUTTON}>
            Submit
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default ShareModal
